import { Box, Switch, Typography } from "@mui/material";
import { COLORS } from "assets";

export interface FormRowSwitchProps {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export default function FormRowSwitch({ label, description, checked, onChange }: FormRowSwitchProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        py: description ? 1 : 0.5
      }}
    >
      <Box flex={1} minWidth={0}>
        <Typography sx={{ color: COLORS.surface.primaryText, fontWeight: 500, fontSize: 15 }}>{label}</Typography>
        {description ? (
          <Typography variant="body2" sx={{ color: COLORS.surface.secondaryText, mt: 0.25 }}>
            {description}
          </Typography>
        ) : null}
      </Box>
      <Switch
        checked={checked}
        onChange={(_, next) => onChange(next)}
        sx={{
          flexShrink: 0,
          "& .MuiSwitch-switchBase.Mui-checked": {
            color: COLORS.primary,
            "& + .MuiSwitch-track": {
              bgcolor: COLORS.primary,
              opacity: 0.5
            }
          }
        }}
      />
    </Box>
  );
}
